import styled from 'styled-components';

import DropSvg from 'assets/drop-logo.svg';

export const DropLogo = styled(DropSvg)`
  height: 32px;
  width: 142px;
`;
